import React from 'react';
import { motion } from 'framer-motion';
import { Globe, ShieldCheck, Wallet, HandHeart } from 'lucide-react';
const features = [{
  icon: Globe,
  title: 'Global Selection',
  subtitle: '全球甄选',
  description: 'Curated selection of beautiful companions from around the world.'
}, {
  icon: ShieldCheck,
  title: 'Verified Profiles',
  subtitle: '真实认证',
  description: 'Every profile is rigorously authenticated for your peace of mind.'
}, {
  icon: Wallet,
  title: 'No Deposit',
  subtitle: '无需定金',
  description: 'Zero upfront payment required. We value trust above all else.'
}, {
  icon: HandHeart,
  title: 'Pay After Meeting',
  subtitle: '见面付款',
  description: 'Satisfaction guaranteed. Payment is only made when you meet.'
}];
export function Features() {
  return <section className="py-24 bg-[#0A0A0A] relative" data-id="element-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-3">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group p-8 border border-[#333] bg-[#111]/50 backdrop-blur-sm hover:border-[#D4AF37]/50 transition-colors duration-300" data-id="element-4">
              <div className="mb-6 inline-block p-3 rounded-full bg-[#D4AF37]/10 text-[#D4AF37] group-hover:bg-[#D4AF37] group-hover:text-black transition-colors duration-300" data-id="element-5">
                <feature.icon className="w-8 h-8" data-id="element-6" />
              </div>
              <h3 className="text-xl font-serif text-white mb-1" data-id="element-7">
                {feature.title}
              </h3>
              <p className="text-[#D4AF37] text-sm mb-4 font-medium tracking-wide" data-id="element-8">
                {feature.subtitle}
              </p>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-9">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}